import {
  CV_FIELDSET_KEY_MAP,
  CV_FIELDSET_INITIAL_VALUES,
  KEYS_TO_STORE
} from './constants';

export const localStorageHandler = ({
  getFieldProps,
  previousRadioId,
  setRadioSelected,
  nextRadioId
}) => {
  const previousRadioKey = CV_FIELDSET_KEY_MAP[previousRadioId];
  const nextRadioKey = CV_FIELDSET_KEY_MAP[nextRadioId];
  const previousRadioInitialValue =
    CV_FIELDSET_INITIAL_VALUES[previousRadioKey];

  const nextRadioSavedValues = localStorage.getItem(nextRadioKey);

  const shouldAddToLocalStorage = KEYS_TO_STORE.includes(previousRadioKey);
  const shouldGetFromLocalStorage =
    KEYS_TO_STORE.includes(nextRadioKey) && nextRadioSavedValues;

  if (shouldAddToLocalStorage) {
    const {
      value: previousRadioValue,
      setValue: previousRadioSetValue,
      setUntouched: previousRadioSetUntouched
    } = getFieldProps(previousRadioKey);
    localStorage.setItem(previousRadioKey, JSON.stringify(previousRadioValue));
    previousRadioSetValue(previousRadioInitialValue);
    previousRadioSetUntouched();
  }

  setRadioSelected(nextRadioId);

  if (shouldGetFromLocalStorage) {
    const { setValue: nextRadioSetValue } = getFieldProps(nextRadioKey);
    const parsedValue = JSON.parse(nextRadioSavedValues);
    nextRadioSetValue(parsedValue);
  }
};

export const clearLocalStorage = () => {
  Object.values(CV_FIELDSET_KEY_MAP).forEach(localStorageItem =>
    localStorage.removeItem(localStorageItem)
  );
};

export const urlHandler = value => {
  if (!value) return value;
  return /^https?:\/\//.test(value) ? value : `https://${value}`;
};
